<template>
  <div class="footer">

    <p class="footer__copyright">
      © 2022 | All rights reserved.
    </p>

    <div class="flex">
      <nav class="footer__nav">
        <a href="mailto:help@mybot.az" class="footer__link">help@mybot.az</a>
        <ul class="footer__social">
          <li><a href=""><img src="@/assets/main/insta.svg" alt="Botlar.az"></a></li>
          <li><a href=""><img src="@/assets/main/telegram-mini.svg" alt="Botlar.az"></a></li>
        </ul>
      </nav>
      <div class="right-menu">
        <a href="https://www.instagram.com/botlar.az/" class="footer__link">About</a>
      </div>
    </div>
  </div>
</template>
<script>

export default {
}
</script>